import { SET_PROMOTION_INFO, SET_REDIRECT_404, SET_STATUS_TYPE, RESET_PROMOTION_INFO } from "../actions/promotionInfo";

const initialState = {
  promo_code: null,
  expiry_date: null,
  title: null,
  description: null,
  install_cost: null,
  free_months: null,
  redirect: false,
  status: false
};

const promotion_info = (state = initialState, action) => {
  switch (action.type) {
    case SET_PROMOTION_INFO:
      return { ...state, ...action.payload };
    case SET_REDIRECT_404:
      return { ...state, redirect: action.payload };
    case SET_STATUS_TYPE:
      return { ...state, status: action.payload };
    case RESET_PROMOTION_INFO:
      return initialState;
    default:
      return state;
  }
};

export default promotion_info;



// WEBPACK FOOTER //
// ./src/store/reducers/promotionInfo.js